import React, { useLayoutEffect, useRef, useState } from 'react';

const GAP = 4;
const MORE_WIDTH = 34;

const chipStyle = {
  display: 'inline-block',
  backgroundColor: 'var(--bg-neutral-layer03)',
  color: 'var(--fg-neutral-default)',
  borderRadius: 'var(--radius-small)',
  padding: '2px var(--space-8)',
  fontSize: 'var(--fs-13)',
  lineHeight: 'var(--lh-reading)',
  whiteSpace: 'nowrap',
  flexShrink: 0,
};

export function AddonsCell({ addons = [] }) {
  const containerRef = useRef(null);
  const measureRef = useRef(null);
  const [visibleCount, setVisibleCount] = useState(addons.length);

  useLayoutEffect(() => {
    const container = containerRef.current;
    const measure = measureRef.current;
    if (!container || !measure) return undefined;

    const calculate = () => {
      const available = container.clientWidth;
      const widths = Array.from(measure.children).map((c) => c.offsetWidth);
      const total = widths.reduce((sum, w) => sum + w, 0) + GAP * (widths.length - 1);

      if (total <= available) {
        setVisibleCount(widths.length);
        return;
      }

      let used = 0;
      let count = 0;
      for (let i = 0; i < widths.length; i += 1) {
        const next = used + widths[i] + (count > 0 ? GAP : 0);
        if (next + GAP + MORE_WIDTH > available) break;
        used = next;
        count += 1;
      }
      setVisibleCount(count);
    };

    calculate();
    const observer = new ResizeObserver(calculate);
    observer.observe(container);
    return () => observer.disconnect();
  }, [addons]);

  if (!addons.length) return <span>-</span>;

  const hidden = addons.length - visibleCount;

  return (
    <div
      ref={containerRef}
      style={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        gap: `${GAP}px`,
        width: '100%',
        overflow: 'hidden',
      }}
      title={addons.map((a) => a.itemName).join(', ')}
    >
      <div
        ref={measureRef}
        aria-hidden
        style={{
          position: 'absolute',
          visibility: 'hidden',
          pointerEvents: 'none',
          display: 'flex',
          gap: `${GAP}px`,
        }}
      >
        {addons.map((a, i) => (
          <span key={a.id ?? `${a.itemName}-${i}`} style={chipStyle}>
            {a.itemName}
          </span>
        ))}
      </div>
      {addons.slice(0, visibleCount).map((a, i) => (
        <span key={a.id ?? `${a.itemName}-${i}`} style={chipStyle}>
          {a.itemName}
        </span>
      ))}
      {hidden > 0 && (
        <span style={{ ...chipStyle, padding: '2px 6px' }}>+{hidden}</span>
      )}
    </div>
  );
}
